<div class="testimonial-section">
  <div class="background-container">
    <img src="/assets/images/home/background.png" alt="" class="background-image" />
  </div>

  <div class="testimonial-content">
    <div class="cards-container">
      <div class="testimonial-card-image">
        <img [src]="currentImage" alt="" class="card-image" />
        <div class="overlay-gradient"></div>
        <div class="logo-container">
          <img [src]="currentLogo" alt="" class="logo" />
        </div>
      </div>

      <div class="testimonial-main">
        <div class="title-section">
          <p class="main-title">{{ headingKey | translateLang }}</p>
          <div class="eyebrow-heading">
            <p class="eyebrow-text">{{ subheadingKey | translateLang }}</p>
          </div>
        </div>

        <div class="caption-card">
          <div class="caption-content">
            <div class="name-position">
              <p class="name">{{ currentTestimonial.name }}</p>
              <p class="position">{{ currentTestimonial.position }}</p>
            </div>
            <div class="divider"></div>
            <p class="quote">{{ truncatedQuote }}</p>
          </div>
        </div>

        @if (testimonials.length > 1) {
          <div class="navigation-arrows">
            <button class="arrow-button arrow-prev" (click)="previousTestimonial()" aria-label="Previous testimonial">
              <img src="/assets/images/home/Icons/ooui_next-left.svg" alt="" class="arrow-icon" />
            </button>
            <button class="arrow-button arrow-next" (click)="nextTestimonial()" aria-label="Next testimonial">
              <img src="/assets/images/home/Icons/ooui_next-right.svg" alt="" class="arrow-icon" />
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
